export default class Global {

    constructor() {
        this.noImage();
        this.sidebar();
        this.preloaderAnimation();
        this.mobileTabs();
    }

    noImage() {
        $("img").on("error", function(){
            $(this).attr("src", "/images/admin-panel/no-image.png");
        });
        $(document).ajaxComplete(function(){
            $("img").off("error");
            $("img").on("error", function(){
                $(this).attr("src", "/images/admin-panel/no-image.png");
            });
        });
    }

    sidebar() {
        const storageKey = 'brain_sidebar_collapsed';
        const desktopMinWidth = 768;
        const isDesktop = () => $(window).width() > desktopMinWidth;

        const readCollapsedPreference = () => {
            try {
                const value = localStorage.getItem(storageKey);
                if (value === '1') {
                    return true;
                }
                if (value === '0') {
                    return false;
                }
            } catch (e) {
                // localStorage non disponibile
            }
            return null;
        };

        const writeCollapsedPreference = (collapsed) => {
            try {
                localStorage.setItem(storageKey, collapsed ? '1' : '0');
            } catch (e) {
                // localStorage non disponibile
            }
        };

        const applyCollapsedState = (collapsed) => {
            if (!isDesktop()) {
                return;
            }
            if (collapsed) {
                $('body').addClass('sidebar-collapse');
            } else {
                $('body').removeClass('sidebar-collapse');
            }
        };

        if (breakpoint('sm')) {
            $('body').removeClass('fixed');
        }

        const savedCollapsed = readCollapsedPreference();
        if (savedCollapsed !== null) {
            applyCollapsedState(savedCollapsed);
        } else if (breakpoint('md') && isDesktop()) {
            // Prima visita: collassa automaticamente sotto lg (comportamento storico)
            applyCollapsedState(true);
            writeCollapsedPreference(true);
        }

        $(document).on('collapsed.pushMenu', function () {
            if (isDesktop()) {
                writeCollapsedPreference(true);
            }
        });

        $(document).on('expanded.pushMenu', function () {
            if (isDesktop()) {
                writeCollapsedPreference(false);
            }
        });
    }

    preloaderAnimation() {
        new WOW.WOW({ mobile: false }).init();

        $("#status").fadeOut();
        $("#preloader").fadeOut("slow");

        if(window.location.hash){
            $('html, body').animate({
                scrollTop: $(window.location.hash).offset().top
            }, 500);
        }
    }

    mobileTabs() {
        if(breakpoint("xs")){
            $('.nav-tabs').not('.slick-initialized').slick({
                infinite: false,
            });
            $('.nav-tabs').on('beforeChange', function(event, slick, currentSlide, nextSlide){
                var tabID = $(slick.$slides[nextSlide]).find("a").attr("href");
                var tab = $(tabID);
                $(slick.$slides[nextSlide]).find("a").trigger("click");
                $('.tab-pane').removeClass("active");
                $('.tab-pane').hide();
                tab.addClass('active');
                tab.fadeIn();
                tab.animate({
                    scrollTop: 0
                });
            });
        }
    }
}
